// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__pWrTf","Logo":"Footer_Logo__kAr1e","title2":"Footer_title2__1VN6Y","column":"Footer_column__zN0pw","title":"Footer_title__KQB9s","text":"Footer_text__5nrk+"};